import React from 'react';
import { Home } from '../components/Home';

const HomePage: React.FC = () => {	
	return (
		<div className="min-h-screen">
			<Home/>
		</div>
	);
};

export default HomePage;